export default function () {
  // (function (l) {
  //   var i, s = {
  //     touchend: function () {
  //     }
  //   };
  //   for (i in s)l.addEventListener(i, s)
  // })(document);
  //
  // let el = document.getElementById('main');
  // el.classList.remove('can-hover');
  // document.activeElement.blur();
  // setTimeout(() => {
  //   el.classList.add('can-hover');
  // }, 1000);
  // document.addEventListener()
}